import DateFormatter from "@/helpers/formatters/date.formatter.js";
import BadgeFormatter from "@/helpers/formatters/badge.formatter.js";

class DriverFormatter {

    driverFormat(data) {
        if (!data) return null;

        return {
            id: data.id ?? null,
            clientId: data.clientId ?? null,
            firstName: data.firstName ?? null,
            lastName: data.lastName ?? null,
            lastActivity: data.lastActivity ?? null,
            displayLastActivity: DateFormatter.formatDate(data.lastActivity),
            status: data.status ?? "ACTIVE",
            badges: BadgeFormatter.badgesFormat(data.badges),
        };
    }

    driversFormat(data) {
        if (!Array.isArray(data)) return [];

        return data
            .map(driver => this.driverFormat(driver))
            .filter(Boolean);
    }
}

export default new DriverFormatter();